module.exports = __webpack_public_path__ + "static/media/3DPPA3.bcac0eb6.jpg";